import { GeneralStyle } from '@website-builder/model/style/general-style';

export class MenuStyle extends GeneralStyle {
  margin = 'uk-margin-remove';
  background = '';
  padding = '';
  itemsSpacing = 'uk-padding-small';
  dropdownTextAlignment = '';
  style = '';
  fontFamily = '';
  color = '';
  gridWidth = 'uk-width-large';
  gridDividers = '';
  columns = 'uk-child-width-1-2';
  hoverStyle = '';
  positioning = 'uk-flex-center';
  sectionSpacing = 'uk-margin';
  sectionBackground = '';
  border = 'tb-border-small tb-border-default';
  height = 60;
  verticalBorder = 'vertical-border';
  iconColor = '';
  iconHoverColor = '';
  iconPosition = 'uk-flex-row';
  iconMargin = 'uk-margin-small-right';
  socialDecoration = '';
  socialDecorationColor = '';
  socialColor = '';
  socialSize = 'tb-icon-medium';
  socialGap = '';

  static normalize(styles: Partial<MenuStyle>): MenuStyle {
    const generalStyle: GeneralStyle = GeneralStyle.normalize(styles);
    const pureStyles = new MenuStyle();

    Object.assign(pureStyles, generalStyle);

    pureStyles.margin = styles.margin ?? pureStyles.margin;
    pureStyles.background = styles.background ?? pureStyles.background;
    pureStyles.padding = styles.padding ?? pureStyles.padding;
    pureStyles.itemsSpacing = styles.itemsSpacing ?? pureStyles.itemsSpacing;
    pureStyles.dropdownTextAlignment = styles.dropdownTextAlignment ?? pureStyles.dropdownTextAlignment;
    pureStyles.style = styles.style ?? pureStyles.style;
    pureStyles.fontFamily = styles.fontFamily ?? pureStyles.fontFamily;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.gridWidth = styles.gridWidth ?? pureStyles.gridWidth;
    pureStyles.gridDividers = styles.gridDividers ?? pureStyles.gridDividers;
    pureStyles.columns = styles.columns ?? pureStyles.columns;
    pureStyles.hoverStyle = styles.hoverStyle ?? pureStyles.hoverStyle;
    pureStyles.positioning = styles.positioning ?? pureStyles.positioning;
    pureStyles.sectionSpacing = styles.sectionSpacing ?? pureStyles.sectionSpacing;
    pureStyles.sectionBackground = styles.sectionBackground ?? pureStyles.sectionBackground;
    pureStyles.border = styles.border ?? pureStyles.border;
    pureStyles.height = styles.height ?? pureStyles.height;
    pureStyles.verticalBorder = styles.verticalBorder ?? pureStyles.verticalBorder;
    pureStyles.iconColor = styles.iconColor ?? pureStyles.iconColor;
    pureStyles.iconHoverColor = styles.iconHoverColor ?? pureStyles.iconHoverColor;
    pureStyles.iconPosition = styles.iconPosition ?? pureStyles.iconPosition;
    pureStyles.iconMargin = styles.iconMargin ?? pureStyles.iconMargin;
    pureStyles.socialDecoration = styles.socialDecoration ?? pureStyles.socialDecoration;
    pureStyles.socialDecorationColor = styles.socialDecorationColor ?? pureStyles.socialDecorationColor;
    pureStyles.socialColor = styles.socialColor ?? pureStyles.socialColor;
    pureStyles.socialSize = styles.socialSize ?? pureStyles.socialSize;
    pureStyles.socialGap = styles.socialGap ?? pureStyles.socialGap;

    return pureStyles;
  }
}
